import { useApplicationModals } from "app/common/hooks";
import { Badge } from "app/components/atoms/badge";
import { Button } from "app/components/atoms/button";
import Typography from "app/components/atoms/typography";
import ImageWithPreview from "app/components/molecules/imageWithPreview";
import { ModalMolecule } from "app/components/molecules/modal";
import { useFetcher } from "app/integration/common/hooks";
import ClientLogo from "img/client-logo.webp";
import { Fragment, useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import { filter as _filter } from "underscore";

function ViewInvoiceModal({ onSuccess = () => { } }) {
  const [queryParams, setQueryParams] = useState({
    // delivery_slip: 1,
    order_ids: "",
  });

  const [report] = useFetcher({
    modelName: "invoice",
    payload: { id: queryParams },
  });

  const { showStates, getPayloads, closeModal } = useApplicationModals();
  const payload = getPayloads("invoice.view");
  if (payload?.data?.items?.length > 0) {
    console.log("payload: ", payload);
    console.log("data: ", payload.data);
  }
  const invoice = payload?.data;

  const localHelpers = {
    subtotal: (customerId) => {
      return _filter(invoice?.sales_orders, {
        customer_id: customerId,
        invoice_id: invoice?.id,
      })
        .map((salesOrder) => {
          return salesOrder?.OrderItems.map(
            (orderDetail) =>
              orderDetail.qty * (orderDetail.unit_price - orderDetail.discount_reseller)
          ).reduce((partialSum, a) => partialSum + a, 0);
        })
        .reduce((partialSum, a) => partialSum + a, 0);
    },
    shipmentCost: (customerId) => {
      return _filter(invoice?.sales_orders, {
        customer_id: customerId,
        invoice_id: invoice?.id,
      })
        .map((salesOrder) => {
          return Number(salesOrder.delivery_fee);
        })
        .reduce((partialSum, a) => partialSum + a, 0);
    },
    shipmentCostDiscount: (customerId) => {
      return _filter(invoice?.sales_orders, {
        customer_id: customerId,
        invoice_id: invoice?.id,
      })
        .map((salesOrder) => {
          return Number(salesOrder.delivery_fee_discount);
        })
        .reduce((partialSum, a) => partialSum + a, 0);
    },
    total: (customerId) => {
      return (
        +localHelpers.subtotal(customerId) +
        +localHelpers.shipmentCost(customerId)
        // +localHelpers.shipmentCostDiscount(customerId)
      );
    },
    payment: (payments) => {
      var total = 0;
      payments?.map((payment, key) => (total += Number(payment.total_payment)));
      return total;
    },
    subTotalPerProduct: (orderItems) => {
      return orderItems?.reduce((total, order) => {
        total += Number(order.unit_price - order.discount_reseller) * Number(order.qty);
        return total;
      }, 0);
    },
    discountTransaction: (customer_id) => {
      console.log("initial sales", invoice?.sales_orders);
      return _filter(invoice?.sales_orders, {
        customer_id: customer_id,
        invoice_id: invoice?.id,
      }).reduce((a, b) => {
        return Number(a) + Number(b.discount_transaction);
      }, 0);
    },
    totalAfterDiscount: (customer_id) => {
      return (
        +localHelpers.subtotal(customer_id) +
        localHelpers.shipmentCost(customer_id) -
        localHelpers.discountTransaction(customer_id)
      );
    },
  };

  const handleClose = () => closeModal("invoice.view");
  const handleSuccess = () => {
    closeModal("invoice.view");
    onSuccess();
  };

  useEffect(() => {
    if (payload?.data?.length > 0) {
      console.log("payload: ", payload.data);
      const order_ids = payload.data.map((item) => {
        return item.order_id;
      });

      setQueryParams({
        ...queryParams,
        order_ids: order_ids.join(","),
      });
    } else {
      console.log("payload kosong");
    }
  }, [payload]);

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <ModalMolecule
      show={showStates["invoice.view"]}
      title="View Invoice"
      onClose={handleClose}
      size="xl"
    >
      <div
        ref={componentRef}
        className="space-y-1 text-sm border border-gray-100 shadow-xl print:shadow-none print:border-none print:break-inside-avoid"
      >
        <div>
          <div className="w-full bg-white flex justify-between px-8 py-4">
            <div>
              <h1 className="text-4xl font-bold text-black">Invoice</h1>
              <p className="text-sm font-medium text-yellow-500">
                {invoice?.inv_code}
              </p>
            </div>
            <img alt={process.env.REACT_APP_CLIENT_NAME} src={ClientLogo} className="w-48 object-contain"></img>
          </div>
          <div className="px-8 py-4 flex justify-between">
            <div>
              <p className="text-lg font-bold">{invoice?.customerName}</p>
              <p className="text-sm font-medium text-gray-500">
                {invoice?.customerPhone}
              </p>
            </div>
            <div className="">
              <Typography.Date date={new Date().toISOString()}></Typography.Date>
            </div>
          </div>
        </div>
        <div className="px-4 sm:px-8 py-4">
          <div className="min-w-full overflow-x-auto">
            <table className="w-full border border-gray-200">
              <thead>
                <tr className="bg-gray-100">
                  <th className="p-2 text-left text-xs font-medium text-gray-600">Order</th>
                  <th className="p-2 text-right text-xs font-medium text-gray-600">Harga</th>
                  <th className="p-2 text-right text-xs font-medium text-gray-600">Diskon</th>
                  <th className="p-2 text-right text-xs font-medium text-gray-600">Qty</th>
                  <th className="p-2 text-right text-xs font-medium text-gray-600">Ongkir</th>
                  <th className="p-2 text-right text-xs font-medium text-gray-600">Subtotal</th>
                  <th className="p-2 text-right text-xs font-medium text-gray-600">Diskon Order</th>
                  <th className="p-2 text-right text-xs font-medium text-gray-600">Total</th>
                </tr>
              </thead>
              <tbody>
                {invoice?.sales_orders?.map((salesOrder, key) => (
                  <Fragment key={key}>
                    <tr className="bg-white">
                      <td 
                        className="p-2 text-sm font-semibold border-b border-gray-200"
                        colSpan={4}
                      >
                        {salesOrder.order_code}
                        <p className="text-xs text-gray-500 font-normal">Dikirim ke: {salesOrder.Address?.desc}</p>
                        {salesOrder.note_order && (
                          <p className="text-xs text-gray-500 font-normal">Catatan: {salesOrder.note_order}</p>
                        )}
                      </td>
                      <td 
                        className="p-2 text-sm font-semibold border-b border-gray-200 text-right"
                      >
                        {Number(salesOrder.delivery_fee)}
                        
                      </td>
                      <td 
                        className="p-2 text-sm font-semibold border-b border-gray-200 text-right"
                      >
                        {localHelpers.subTotalPerProduct(salesOrder.OrderItems)}
                      </td>
                      <td 
                        className="p-2 text-sm font-semibold border-b border-gray-200 text-right"
                      >
                        {salesOrder.discount_transaction}
                      </td>
                      <td 
                        className="p-2 text-sm font-semibold border-b border-gray-200 text-right"
                      >
                        {localHelpers.subTotalPerProduct(salesOrder.OrderItems) + Number(salesOrder.delivery_fee) - Number(salesOrder.discount_transaction)}
                      </td>
                    </tr>
                    {salesOrder.OrderItems.map((orderItem, itemKey) => (
                      <tr key={`${key}-${itemKey}`} className="bg-white hover:bg-gray-50">
                        <td className="p-2 text-sm border-b border-gray-200">
                          <div className="flex flex-col">
                            <span className="font-medium">{orderItem.master_product.name}</span>
                            <span className="text-xs text-gray-500">{orderItem.master_product.code}</span>
                            <div className="flex flex-wrap gap-1 mt-1">
                              <span className="px-2 py-0.5 text-xs bg-gray-100 rounded text-gray-700">
                                {orderItem.master_color.name}
                              </span>
                              <span className="px-2 py-0.5 text-xs bg-gray-100 rounded text-gray-700">
                                {orderItem.master_size.name}
                              </span>
                            </div>
                            {orderItem.notes && (
                              <span className="text-xs text-gray-500">Catatan: {orderItem.notes}</span>
                            )}
                          </div>
                        </td>
                        <td className="p-2 text-sm text-right border-b border-gray-200 text-right">
                          <Typography.Currency number={orderItem.unit_price} />
                        </td>
                        <td className="p-2 text-sm text-right border-b border-gray-200 text-right">
                          <Typography.Currency number={orderItem.discount_reseller} />
                        </td>
                        <td className="p-2 text-sm text-right border-b border-gray-200 text-right">
                          {orderItem.qty}
                        </td>
                        <td className="p-2 text-sm text-right border-b border-gray-200 text-right">
                        </td>
                        <td className="p-2 text-sm text-right border-b border-gray-200 text-right">
                        <Typography.Currency number={orderItem.qty * (orderItem.unit_price - orderItem.discount_reseller)} />
                        </td>
                        <td className="p-2 text-sm text-right border-b border-gray-200 text-right">
                        </td>
                        <td className="p-2 text-sm text-right border-b border-gray-200 text-right">
                        </td>
                      </tr>
                    ))}
                  </Fragment>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <hr />
        <div className="w-full flex flex-col md:flex-row justify-between items-end px-10 py-4 gap-8 md:gap-0">
          <div className="w-full md:w-1/2 text-gray-700">
            <h3 className="uppercase text-[10px] tracking-tight leading-tight font-medium ">
              Keterangan Pembayaran
            </h3>
            <p className="text-[10px] tracking-tight leading-tight font-extralight mt-2">
              Untuk melakukan pembayaran, harap transfer ke:
            </p>
            <div className="grid grid-cols-2 text-[10px] tracking-tight leading-tight w-fit gap-y-1 mt-1 pl-2">
              <span className="">Bank:</span>
              <span>{process.env.REACT_APP_REK_BANK}</span>
              <span className="">Nama:</span>
              <span>{process.env.REACT_APP_REK_NAME}</span>
              <span className="">Rekening:</span>
              <span>{process.env.REACT_APP_REK_NO}</span>
            </div>
          </div>
          <div className="h-full w-fit grid grid-cols-2 items-center gap-y-1 gap-x-2 text-right">
            <div className="text-xs uppercase text-gray-600 text-right font-light">
              Subtotal:{" "}
            </div>
            <Typography.Currency
              number={localHelpers.subtotal(invoice?.customer_id)}
            />
            {console.log("customer id:", invoice?.customer_id)}
            <div className="text-xs uppercase text-gray-600 text-right font-light">
              Ongkir:{" "}
            </div>
            <Typography.Currency
              number={localHelpers.shipmentCost(invoice?.customer_id)}
            />
            {/* <div className="text-xs uppercase text-gray-600 text-right font-light">
              Diskon Ongkir:{" "}
            </div>
            <Typography.Currency
              number={-localHelpers.shipmentCostDiscount(invoice?.customer_id)}
            /> */}
            {/* <div className="col-span-2 my-3"></div> */}

            <div className="text-xs uppercase text-gray-600 text-right font-light">
              Total:{" "}
            </div>
            <Typography.Currency
              number={localHelpers.total(invoice?.customer_id)}
            />
            <div className="text-xs uppercase text-gray-600 text-right font-light">
              Diskon Transaksi:{" "}
            </div>
            <Typography.Currency
              number={localHelpers.discountTransaction(invoice?.customer_id)}
            />
            <div className="col-span-2">
              <hr />
            </div>

            {invoice?.isUseCredit ? (
              <>
                <div className="text-xs uppercase text-right font-light text-primary-600">
                  Kredit Customer:{" "}
                </div>
                <div className="text-primary-600">
                  <Typography.Currency number={invoice?.creditAmount} />
                </div>
              </>
            ) : (
              <></>
            )}

            {invoice?.total_payment > 0 ?
              <>
                <div
                  className="text-xs uppercase text-primary-600 text-right font-light"
                >
                  Pembayaran:{" "}
                </div>
                <Typography.Currency number={invoice?.total_payment} />
              </> : <></>
            }
            <div className="text-sm uppercase text-gray-600 text-right font-bold">
              Sisa Tagihan:{" "}
            </div>
            <Typography.Currency
              number={
                localHelpers.totalAfterDiscount(invoice?.customer_id) -
                invoice?.total_payment
              }
            />
          </div>
        </div>
      </div>
      <div className="fixed bottom-2 left-0 sm:left-auto right-0 sm:right-4 sm:bottom-4 sm:w-auto z-40 flex justify-end border-t border-gray-100 bg-white sm:bg-transparent p-4 sm:p-0 dark:border-gray-700 dark:bg-gray-800 print:hidden sm:absolute sm:rounded-b-lg sm:border-0 ">
        <Button testId="modal-view-invoice-print-invoice-button" 
          onClick={handlePrint} 
          type="button"
          className="print:hidden"
        >
          Print Invoice
        </Button>
      </div>
      <div className="hidden print:block print:break-before-page mt-8">
        <div className="w-full flex flex-col md:flex-row justify-between items-end px-10 py-4 gap-8 md:gap-0">
          <div className="w-full md:w-1/2 text-gray-700">
            <h3 className="uppercase text-[10px] tracking-tight leading-tight font-medium ">
              Keterangan Pembayaran
            </h3>
            <p className="text-[10px] tracking-tight leading-tight font-extralight mt-2">
              Untuk melakukan pembayaran, harap transfer ke:
            </p>
            <div className="grid grid-cols-2 text-[10px] tracking-tight leading-tight w-fit gap-y-1 mt-1 pl-2">
              <span className="">Bank:</span>
              <span>{process.env.REACT_APP_REK_BANK}</span>
              <span className="">Nama:</span>
              <span>{process.env.REACT_APP_REK_NAME}</span>
              <span className="">Rekening:</span>
              <span>{process.env.REACT_APP_REK_NO}</span>
            </div>
          </div>
          <div className="h-full w-fit grid grid-cols-2 items-center gap-y-1 gap-x-2 text-right">
            <div className="text-xs uppercase text-gray-600 text-right font-light">
              Subtotal:{" "}
            </div>
            <Typography.Currency
              number={localHelpers.subtotal(invoice?.customer_id)}
            />
            <div className="text-xs uppercase text-gray-600 text-right font-light">
              Ongkir:{" "}
            </div>
            <Typography.Currency
              number={localHelpers.shipmentCost(invoice?.customer_id)}
            />
            <div className="text-xs uppercase text-gray-600 text-right font-light">
              Total:{" "}
            </div>
            <Typography.Currency
              number={localHelpers.total(invoice?.customer_id)}
            />
            <div className="text-xs uppercase text-gray-600 text-right font-light">
              Diskon Transaksi:{" "}
            </div>
            <Typography.Currency
              number={localHelpers.discountTransaction(invoice?.customer_id)}
            />
            <div className="col-span-2">
              <hr />
            </div>
            {invoice?.isUseCredit && (
              <>
                <div className="text-xs uppercase text-right font-light text-primary-600">
                  Kredit Customer:{" "}
                </div>
                <div className="text-primary-600">
                  <Typography.Currency number={invoice?.creditAmount} />
                </div>
              </>
            )}
            {invoice?.total_payment > 0 && (
              <>
                <div className="text-xs uppercase text-primary-600 text-right font-light">
                  Pembayaran:{" "}
                </div>
                <Typography.Currency number={invoice?.total_payment} />
              </>
            )}
            <div className="text-sm uppercase text-gray-600 text-right font-bold">
              Sisa Tagihan:{" "}
            </div>
            <Typography.Currency
              number={
                localHelpers.totalAfterDiscount(invoice?.customer_id) -
                (invoice?.total_payment || 0)
              }
            />
          </div>
        </div>
      </div>
    </ModalMolecule>
  );
}

export default ViewInvoiceModal;
